import { GiftCardTier } from "@/models/gift-card-tiers/GiftCardTier";

export const sortGiftCardTiers = (tiers: GiftCardTier[]) => {
  return tiers.sort((tierOne: GiftCardTier, tierTwo: GiftCardTier) => {
    return +tierOne.min - +tierTwo.min;
  });
};
